import { TkitUtils as Utils } from '@tkit/types';
import createModel, { Tction } from '@tkit/model';
import { IRootState, ListPane } from '@src/types';
import { APIS, GlobalSearchInfoCondition, ParamssearchBarUsingGet } from '@src/services';

import { PAGE_SIZE } from '@src/utils/constant/common';

export interface SearchData {
  isSearching: boolean;
  list: GlobalSearchInfoCondition[];
}

export interface NotificationData {
  num: number;
}

export interface AppModelState {
  search: SearchData;
  notification: NotificationData;
}

export const appModelState: AppModelState = {
  search: { isSearching: false, list: [] },
  notification: {
    num: 0
  }
};

const model = createModel({
  state: appModelState,
  namespace: 'appModel',
  reducers: {
    updateAppSearchIsSearching: (state, action: Tction<boolean>) => {
      return {
        ...state,
        search: { ...state.search, isSearching: action.payload }
      };
    },
    updateAppSearchList: (state, action: Tction<GlobalSearchInfoCondition[]>) => {
      return {
        ...state,
        search: { ...state.search, list: action.payload }
      };
    },
    updateAppNotificationNum: (state, action: Tction<number>) => {
      return {
        ...state,
        notification: { ...state.notification, num: action.payload }
      };
    }
  },
  effects: {
    doGetSearchResult: [
      function*(
        { tCall, tPut, select },
        action: Tction<ParamssearchBarUsingGet>
      ): Iterator<{}, any, any> {
        yield tPut(model.actions.updateAppSearchIsSearching, true);

        const res: Utils.GetROA<typeof APIS.SearchApi.searchBarUsingGet> = yield tCall(
          APIS.SearchApi.searchBarUsingGet,
          { keyWord: action.payload.keyWord }
        );

        yield tPut(model.actions.updateAppSearchIsSearching, false);

        if (res.code == 0 && res.result && Array.isArray(res.result)) {
          yield tPut(model.actions.updateAppSearchList, res.result);
        }
      },
      {
        type: 'takeLatest'
      }
    ]
  }
});

export default model;
